unit uSubForm2;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls, WEBLib.Controls, WEBLib.DBCtrls,
  WEBLib.ExtCtrls, WEBLib.Grids, Vcl.Grids;

type
  TSubForm2 = class(TForm)
    WebPanel3: TPanel;
    WebDBGrid1: TDBGrid;
  protected procedure LoadDFMValues; override; end;

var
  SubForm2: TSubForm2;

implementation

{$R *.dfm}

procedure TSubForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel3 := TPanel.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);

  WebPanel3.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  try
    Name := 'SubForm2';
    Width := 640;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 0;
    WebPanel3.Width := 281;
    WebPanel3.Height := 480;
    WebPanel3.Align := alLeft;
    WebPanel3.BorderColor := clWindow;
    WebPanel3.ChildOrder := 13;
    WebPanel3.Color := clWindow;
    WebPanel3.TabOrder := 0;
    WebDBGrid1.SetParentComponent(WebPanel3);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 0;
    WebDBGrid1.Top := 0;
    WebDBGrid1.Width := 281;
    WebDBGrid1.Height := 480;
    WebDBGrid1.Align := alClient;
    WebDBGrid1.BorderColor := clWindow;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      Alignment := taCenter;
      DataField := 'IdUdV';
      Editor := geNumber;
      Title := 'N'#186;
      Width := 57;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'DataMvto';
      Title := 'Data';
      Width := 102;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'descr';
      Title := 'Descri'#231#227'o';
      Width := 220;
    end;
    WebDBGrid1.FixedFont.Charset := DEFAULT_CHARSET;
    WebDBGrid1.FixedFont.Color := clWindowText;
    WebDBGrid1.FixedFont.Height := -12;
    WebDBGrid1.FixedFont.Name := 'Segoe UI';
    WebDBGrid1.FixedFont.Style := [];
    WebDBGrid1.FixedCols := 0;
    WebDBGrid1.Font.Charset := DEFAULT_CHARSET;
    WebDBGrid1.Font.Color := clWindowText;
    WebDBGrid1.Font.Height := -13;
    WebDBGrid1.Font.Name := 'Tahoma';
    WebDBGrid1.Font.Style := [];
    WebDBGrid1.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goEditing,goFixedRowDefAlign];
    WebDBGrid1.ParentFont := False;
    WebDBGrid1.TabOrder := 0;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 57;
    WebDBGrid1.ColWidths[1] := 102;
    WebDBGrid1.ColWidths[2] := 220;
    WebDBGrid1.RowHeights[0] := 22;
    WebDBGrid1.RowHeights[1] := 22;
    WebDBGrid1.RowHeights[2] := 22;
    WebDBGrid1.RowHeights[3] := 59;
    WebDBGrid1.RowHeights[4] := 33;
  finally
    WebPanel3.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
  end;
end;

end.
